import Button from '@mui/material/Button'
import { ComponentProps, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useRxCollection } from 'rxdb-hooks'
import { uuidv7 } from 'uuidv7'

import { AssessmentState } from '@/gql/graphql.ts'
import { Assessment } from '@/system/rxdb/schemas/assessment.ts'
import { AssessmentAdditionalInfo } from '@/system/rxdb/schemas/assessmentAdditionalInfo.ts'
import { AssessmentDetail } from '@/system/rxdb/schemas/assessmentDetail.ts'
import { AssessmentMeasurement } from '@/system/rxdb/schemas/assessmentMeasurement.ts'
import { AssessmentSignature } from '@/system/rxdb/schemas/assessmentSignature.ts'
import { currentDate } from '@/system/rxdb/utils.ts'

import messages from './messages.ts'

const CreateAssessmentButton = (props: ComponentProps<typeof Button>) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const assessment = useRxCollection<Assessment>('assessment')
  const assessmentDetail =
    useRxCollection<AssessmentDetail>('assessment_detail')
  const assessmentAdditionalInfo = useRxCollection<AssessmentAdditionalInfo>(
    'assessment_additional_info'
  )
  const assessmentSignature = useRxCollection<AssessmentSignature>(
    'assessment_signature'
  )
  const assessmentMeasurement = useRxCollection<AssessmentMeasurement>(
    'assessment_measurement'
  )

  const onCreateAssessment = useCallback(async () => {
    const id = uuidv7()
    await assessment?.insert({
      rowId: id,
      updatedAt: currentDate(),
      createdAt: currentDate(),
      state: AssessmentState.Open,
    })
    await assessmentDetail?.insert({
      rowId: uuidv7(),
      assessmentId: id,
      updatedAt: currentDate(),
    })
    await assessmentAdditionalInfo?.insert({
      rowId: uuidv7(),
      assessmentId: id,
      updatedAt: currentDate(),
    })

    await assessmentSignature?.insert({
      rowId: uuidv7(),
      assessmentId: id,
      updatedAt: currentDate(),
    })

    await assessmentMeasurement?.insert({
      rowId: uuidv7(),
      assessmentId: id,
      updatedAt: currentDate(),
    })

    navigate(`/assessment/${id}`)
  }, [
    assessment,
    assessmentDetail,
    assessmentAdditionalInfo,
    navigate,
    assessmentSignature,
    assessmentMeasurement,
  ])

  return (
    <Button onClick={onCreateAssessment} {...props}>
      {formatMessage(messages.create)}
    </Button>
  )
}

export default CreateAssessmentButton
